import WalkthroughRuntime from "~/components/walkthrough/WalkthroughRuntime";
import useLearningMutations from "~/hooks/mutations/useLearningMutations";
import { useLazyMyLearningPathQuery } from "~/services/endpoints/apiEndpoints";
import buildWalkthroughOutcomeVariables, { type EndedWalkthrough } from "~/walkthroughs/walkthroughOutcome";

const WalkthroughController = (): React.JSX.Element => {
	const [fetchLearningPath] = useLazyMyLearningPathQuery();
	const { recordWalkthroughOutcome } = useLearningMutations();

	const recordEndedTour = async (ended: EndedWalkthrough): Promise<void> => {
		const paths = ended.conceptId ? [] : ((await fetchLearningPath(undefined, true)).data?.myLearningPath ?? []);
		const variables = buildWalkthroughOutcomeVariables(ended, paths);
		if (variables) await recordWalkthroughOutcome(variables);
	};

	return <WalkthroughRuntime audience="staff" onEnded={recordEndedTour} />;
};

export default WalkthroughController;
